// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.node-content-container {
  position: relative;
  padding: 16px;
  margin: 16px;
  margin-top: 5%;
  margin-left:4%;
  width: calc(100% - 95px);
}

.node-time-container {
  display: flex;
  justify-content: flex-end; /* Align to right consistently */
  align-items: center;
  padding: 8px;
  gap: 8px;
  height: 1.8rem;
  margin-bottom: 16px;
}
  
  .node-refresh-button {
    background-color: #0C3135;
    color: white;
    font-size: 15px;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    padding: 0.5rem;
    height: 2.0rem;
    width: 2.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0;
  }
  
  .node-refresh-button:hover {
    background-color: #2a5a5a;
  }
  
  .node-refresh-button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
  
  .node-dropbox-table {
    display: flex;
    flex-direction: column;
    gap: 1px;
    padding: 2% 3%;
    padding-right: 5%;
    margin-top: 1%;
    margin-left: 2% !important;
    /* background: whitesmoke; */
    box-shadow: 0 4px 20px rgba(131, 129, 129, 0.08);
    border-radius: 16px;
    padding-left: 1%;
    margin-right: 2%;
  }
  
  .node-dropbox-container {
    margin-left: 1%;
  }
  
  .node-table-container {
    margin: 1% 0;
    padding-left: 10%;
    margin-left: 10%;
    width: 100%;
    padding-bottom: 1%;
    margin-top:0%;
  }
  
  /* Responsive adjustments */
  @media  (max-width: 321px) {
    .node-time-container {
      margin-top: 15%;
      font-size: 5px;
      margin-left: 10%;
    }
    .node-time-container button{
      width:10vw;
    }
    .node-dropbox-table{
      padding: 1% 8%;
      margin-top: 1%;
    }
  }
  
  @media (min-width: 321px) and (max-width: 376px)  {
    .node-time-container {
      margin-top: 13%;
      font-size: 5px;
      margin-left: 12%;
    }
    .node-time-container button{
      width:10vw;
    }
  }
  
  @media  (min-width: 376px) and (max-width: 426px)  {
    .node-time-container {
      margin-top: 10%;
      font-size: 5px;
      margin-left: 8%;
    }
    .node-time-container button{
      width:10vw;
    }
  }
  
  @media (min-width: 426px) and (max-width: 769px) {
    .node-time-container {
      margin-top: 5%;
      font-size: 5px;
      margin-left: 50%;
    }
    .node-time-container button{
      width:5vw;
    }
  }
  
  @media (min-width: 769px) and (max-width: 1025px) {
    .node-time-container {
      margin-top: 2%;
      font-size: 5px;
      margin-left: 50%;
    }
    .node-time-container button{
      width:3vw;
    }
  }
  
  @media (min-width: 1025px) and (max-width: 1441px) {
    .node-time-container {
      margin-top: 0%;
      font-size: 5px;
      margin-left: 63%;
    }
    .node-time-container button{
      width:3vw;
    }
  }
  
  @media (min-width: 1441px) and (max-width: 1921px) {
    .node-time-container {
      margin-top: 0%;
      font-size: 5px;
      margin-left: 65%;
    }
    .node-time-container button{
      width:3vw;
    }
  }
  
  @media (min-width: 1921px){
    .node-time-container {
      margin-top: 0%;
      font-size: 15px;
      margin-left: 78%;
    }
    body{
      font-size: 20px;
    }
  }`, "",{"version":3,"sources":["webpack://./src/components/NodeDashboard/NodeUsage.css"],"names":[],"mappings":";AACA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,cAAc;EACd,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,yBAAyB,EAAE,gCAAgC;EAC3D,mBAAmB;EACnB,YAAY;EACZ,QAAQ;EACR,cAAc;EACd,mBAAmB;AACrB;;EAEE;IACE,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,cAAc;IACd,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,cAAc;IACd,iBAAiB;IACjB,cAAc;IACd,0BAA0B;IAC1B,4BAA4B;IAC5B,gDAAgD;IAChD,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,aAAa;EACf;;EAEA,2BAA2B;EAC3B;IACE;MACE,eAAe;MACf,cAAc;MACd,gBAAgB;IAClB;IACA;MACE,UAAU;IACZ;IACA;MACE,cAAc;MACd,cAAc;IAChB;EACF;;EAEA;IACE;MACE,eAAe;MACf,cAAc;MACd,gBAAgB;IAClB;IACA;MACE,UAAU;IACZ;EACF;;EAEA;IACE;MACE,eAAe;MACf,cAAc;MACd,eAAe;IACjB;IACA;MACE,UAAU;IACZ;EACF;;EAEA;IACE;MACE,cAAc;MACd,cAAc;MACd,gBAAgB;IAClB;IACA;MACE,SAAS;IACX;EACF;;EAEA;IACE;MACE,cAAc;MACd,cAAc;MACd,gBAAgB;IAClB;IACA;MACE,SAAS;IACX;EACF;;EAEA;IACE;MACE,cAAc;MACd,cAAc;MACd,gBAAgB;IAClB;IACA;MACE,SAAS;IACX;EACF;;EAEA;IACE;MACE,cAAc;MACd,cAAc;MACd,gBAAgB;IAClB;IACA;MACE,SAAS;IACX;EACF;;EAEA;IACE;MACE,cAAc;MACd,eAAe;MACf,gBAAgB;IAClB;IACA;MACE,eAAe;IACjB;EACF","sourcesContent":["\n.node-content-container {\n  position: relative;\n  padding: 16px;\n  margin: 16px;\n  margin-top: 5%;\n  margin-left:4%;\n  width: calc(100% - 95px);\n}\n\n.node-time-container {\n  display: flex;\n  justify-content: flex-end; /* Align to right consistently */\n  align-items: center;\n  padding: 8px;\n  gap: 8px;\n  height: 1.8rem;\n  margin-bottom: 16px;\n}\n  \n  .node-refresh-button {\n    background-color: #0C3135;\n    color: white;\n    font-size: 15px;\n    border: none;\n    border-radius: 8px;\n    cursor: pointer;\n    padding: 0.5rem;\n    height: 2.0rem;\n    width: 2.5rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 0;\n  }\n  \n  .node-refresh-button:hover {\n    background-color: #2a5a5a;\n  }\n  \n  .node-refresh-button:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n  }\n  \n  .node-dropbox-table {\n    display: flex;\n    flex-direction: column;\n    gap: 1px;\n    padding: 2% 3%;\n    padding-right: 5%;\n    margin-top: 1%;\n    margin-left: 2% !important;\n    /* background: whitesmoke; */\n    box-shadow: 0 4px 20px rgba(131, 129, 129, 0.08);\n    border-radius: 16px;\n    padding-left: 1%;\n    margin-right: 2%;\n  }\n  \n  .node-dropbox-container {\n    margin-left: 1%;\n  }\n  \n  .node-table-container {\n    margin: 1% 0;\n    padding-left: 10%;\n    margin-left: 10%;\n    width: 100%;\n    padding-bottom: 1%;\n    margin-top:0%;\n  }\n  \n  /* Responsive adjustments */\n  @media  (max-width: 321px) {\n    .node-time-container {\n      margin-top: 15%;\n      font-size: 5px;\n      margin-left: 10%;\n    }\n    .node-time-container button{\n      width:10vw;\n    }\n    .node-dropbox-table{\n      padding: 1% 8%;\n      margin-top: 1%;\n    }\n  }\n  \n  @media (min-width: 321px) and (max-width: 376px)  {\n    .node-time-container {\n      margin-top: 13%;\n      font-size: 5px;\n      margin-left: 12%;\n    }\n    .node-time-container button{\n      width:10vw;\n    }\n  }\n  \n  @media  (min-width: 376px) and (max-width: 426px)  {\n    .node-time-container {\n      margin-top: 10%;\n      font-size: 5px;\n      margin-left: 8%;\n    }\n    .node-time-container button{\n      width:10vw;\n    }\n  }\n  \n  @media (min-width: 426px) and (max-width: 769px) {\n    .node-time-container {\n      margin-top: 5%;\n      font-size: 5px;\n      margin-left: 50%;\n    }\n    .node-time-container button{\n      width:5vw;\n    }\n  }\n  \n  @media (min-width: 769px) and (max-width: 1025px) {\n    .node-time-container {\n      margin-top: 2%;\n      font-size: 5px;\n      margin-left: 50%;\n    }\n    .node-time-container button{\n      width:3vw;\n    }\n  }\n  \n  @media (min-width: 1025px) and (max-width: 1441px) {\n    .node-time-container {\n      margin-top: 0%;\n      font-size: 5px;\n      margin-left: 63%;\n    }\n    .node-time-container button{\n      width:3vw;\n    }\n  }\n  \n  @media (min-width: 1441px) and (max-width: 1921px) {\n    .node-time-container {\n      margin-top: 0%;\n      font-size: 5px;\n      margin-left: 65%;\n    }\n    .node-time-container button{\n      width:3vw;\n    }\n  }\n  \n  @media (min-width: 1921px){\n    .node-time-container {\n      margin-top: 0%;\n      font-size: 15px;\n      margin-left: 78%;\n    }\n    body{\n      font-size: 20px;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
